import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentMethodsStyle';

import { usePageExitPrompt } from '../../hooks';
import { getPaymentMethodLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(styles);

interface PaymentProcessingProps {
	visible: boolean;
	onLeave?: () => void;
}

const PaymentProcessing = ({ visible, onLeave }: PaymentProcessingProps) => {
	const classes = useStyles();
	const paymentMethodLabels = useSelector(getPaymentMethodLabels);

	const [, setBlockPage] = usePageExitPrompt(false, paymentMethodLabels?.paymentExitMessage, onLeave);

	useEffect(() => setBlockPage(visible), [visible]);

	return (
		<Backdrop className={classes.backdrop} open={visible}>
			<CircularProgress color="inherit" title="Payment in progress" />
		</Backdrop>
	);
};

export default PaymentProcessing;
